import ScaleSlider from './ScaleSlider';

export default ScaleSlider;
